import * as React from "react";
const MontinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 153 151"
        fill="none"
        width="22" height="22"
        {...props}
    >
        <path
            d="M152 77C152 117.869 117.974 151 76.0001 151C34.0264 151 -5.58794e-09 119 0.50007 77C0.50007 36.1309 34.0264 3 76.0001 3C117.974 3 152 36.1309 152 77Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M76.2153 6.80627e-07C88.6325 -0.00165824 100.862 3.02922 111.842 8.82921C122.821 14.6292 132.218 23.0228 139.215 33.2805C146.213 43.5383 150.599 55.3497 151.993 67.6884C153.388 80.027 151.747 92.5195 147.215 104.08L121.215 74.83L117.215 70.39L113.885 72.73L105.995 78.26L80.9053 52L78.6953 49.64L76.2853 47.12L76.2353 47.18L76.1453 47.09L45.0953 79.74L42.6353 77.15L40.4353 74.83L38.0853 72.36L4.47534 102C0.34902 90.4924 -0.950247 78.1614 0.687061 66.0464C2.32437 53.9315 6.85026 42.3878 13.8832 32.3883C20.9162 22.3888 30.2501 14.2267 41.0981 8.59C51.9461 2.95328 63.9903 0.00716216 76.2153 6.80627e-07V6.80627e-07ZM62.3153 8.75C53.2328 10.6322 44.6229 14.3264 37.0004 19.6117C29.378 24.8969 22.8994 31.6648 17.9519 39.5107C13.0044 47.3567 9.68968 56.1196 8.20575 65.2757C6.72183 74.4318 7.09921 83.7931 9.31534 92.8L12.4853 90C8.85185 73.1192 12.0556 55.4865 21.3951 40.9628C30.7345 26.4391 45.4486 16.2081 62.3153 12.51V8.75ZM142.845 93.69C145.21 84.6414 145.709 75.2063 144.311 65.9588C142.914 56.7113 139.649 47.8449 134.717 39.899C129.784 31.9531 123.286 25.094 115.618 19.739C107.951 14.3841 99.2738 10.6452 90.1153 8.75V12.51C98.498 14.3457 106.436 17.8167 113.476 22.7242C120.515 27.6316 126.518 33.8793 131.14 41.1095C135.762 48.3397 138.912 56.4104 140.411 64.8598C141.91 73.3091 141.728 81.9711 139.875 90.35L142.875 93.69H142.845ZM86.4453 8.1C79.6653 7.10093 72.7754 7.10093 65.9953 8.1V24.44H86.4453V8.1ZM76.2153 42.1L86.4453 27.24H65.9953L76.2153 42.1Z"
            fill="#231F20"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.6756 111.275C79.7742 98.1282 116.918 95.8725 143.866 103.047H144.043H143.954L145.303 103.425L143.62 103.027C116.534 101.229 77.4666 115.269 39.24 142C34.8825 139.95 31.5938 137.48 28.5938 134.98C32.4256 132.721 37.0629 130.682 41.1048 128.575C78.8097 108.82 116.141 100.255 143.462 102.997C113.533 96.4289 68.4509 107.121 25.3032 132.53C21.5 129.5 18 125.5 15.3032 122.03C23.5545 118.061 33.0258 114.256 41.6756 111.275Z"
            fill="#231F20"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M111.375 84.2096L116.625 75.2796L108.395 81.0696L111.395 84.2096H111.375ZM76.2055 52.3496L47.6355 82.3996L52.5455 87.5696L76.2055 52.3496ZM37.8555 77.4496L5.85547 105.66C7.16312 108.782 8.6799 111.812 10.3955 114.73L37.8555 77.4496Z"
            fill="#00B8B2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M76.2156 40.2L79.4556 35.5H72.9756L76.2156 40.2Z"
            fill="#00B8B2"
        />
    </svg>
);
export default MontinkIcon;
